import { Failure } from '@geekbears/gb-ngrx-stack-base';
import { AppUser } from '@modules/company-manager/users/domain';
import { createAction, props } from '@ngrx/store';
import { ApiQueryParams } from '@utils/api-query-params.type';

/**
 * Actions For All Users
 */
export const getAllCustomersAction = createAction(
  '[Super Admin] Get All Customers Action'
);
export const getAllCustomersSuccessAction = createAction(
  '[Super Admin] Get All Customers Success Action',
  props<{
    users: {
      data: AppUser[];
    };
  }>()
);
export const getAllCustomersFailureAction = createAction(
  '[Super Admin] Get All Customers Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For All Active Users
 */
export const getAllActiveUsersAction = createAction(
  '[Super Admin] Get All Active Users Action'
);
export const getAllActiveUsersSuccessAction = createAction(
  '[Super Admin] Get All Active Users Success Action',
  props<{
    users: {
      data: AppUser[];
    };
  }>()
);
export const getAllActiveUsersFailureAction = createAction(
  '[Super Admin] Get All Active Users Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For Notifications
 */
export const getNotificationsAction = createAction(
  '[Super Admin] Get Notifications Action',
  props<ApiQueryParams>()
);
export const getNotificationsSuccessAction = createAction(
  '[Super Admin] Get Notifications Success Action',
  props<{
    notifications: any;
  }>()
);
export const getNotificationsFailureAction = createAction(
  '[Super Admin] Get Notifications Failure Action',
  props<{
    failure: Failure;
  }>()
);

/**
 * Actions For Mark As Read Notification
 */
export const markAsReadNotificationAction = createAction(
  '[Super Admin] Mark As Read Notification Action',
  props<{
    notificationId: string;
  }>()
);
export const markAsReadNotificationSuccessAction = createAction(
  '[Super Admin] Mark As Read Notification Success Action',
  props<{
    response: any;
  }>()
);
export const markAsReadNotificationFailureAction = createAction(
  '[Super Admin] Mark As Read Notification Failure Action',
  props<{
    failure: Failure;
  }>()
);

/**
 * Notifications Count
 */
export const getNotificationsCountAction = createAction(
  '[Super Admin] Get Notifications Count Action',
  props<ApiQueryParams>()
);
export const getNotificationsCountSuccessAction = createAction(
  '[Super Admin] Get Notifications Count Success Action',
  props<{
    response: { data: number };
  }>()
);
export const getNotificationsCountFailureAction = createAction(
  '[Super Admin] Get Notifications Count Failure Action',
  props<{
    failure: Failure;
  }>()
);
export const fetchNotificationsAction = createAction(
  '[Super Admin] Fetch Notifications Action',
  props<ApiQueryParams>()
);

export const SuperAdminHomeActions = {
  /**
   * Actions For Get All Users
   */
  getAllCustomers: getAllCustomersAction,
  getAllCustomersSuccess: getAllCustomersSuccessAction,
  getAllCustomersFailure: getAllCustomersFailureAction,
  /**
   * Actions For Get All Users
   */
  getAllActiveUsers: getAllActiveUsersAction,
  getAllActiveUsersSuccess: getAllActiveUsersSuccessAction,
  getAllActiveUsersFailure: getAllActiveUsersFailureAction,
  /**
   * Actions For Get Notifications
   */
  getNotifications: getNotificationsAction,
  getNotificationsSuccess: getNotificationsSuccessAction,
  getNotificationsFailure: getNotificationsFailureAction,

  /**
   * Actions For Mark As Read Company
   */
  markAsReadNotification: markAsReadNotificationAction,
  markAsReadNotificationSuccess: markAsReadNotificationSuccessAction,
  markAsReadNotificationFailure: markAsReadNotificationFailureAction,

  /**
   * Get Notifications Count
   */
  getNotificationsCount: getNotificationsCountAction,
  getNotificationsCountSuccess: getNotificationsCountSuccessAction,
  getNotificationsCountFailure: getNotificationsCountFailureAction,

  /**
   * Fetch Notifications
   */
  fetchNotifications: fetchNotificationsAction,
};
